import React from 'react';
import PropTypes from 'prop-types';
import { Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(() => ({
  circle: {
    borderRadius: '50%',
    backgroundColor: '#AD83B7',
    height: (props) => props.size,
    width: (props) => props.size,
    position: 'relative',
  },
  inner: {
    margin: '0 auto',
    position: 'absolute',
    fontSize: 32,
    fontWeight: 600,
    color: 'white',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
}));

const firstCharacterExtractor = (name) => {
  return name.slice(0, 1).toUpperCase();
};

const ProfileCircle = ({ ...props }) => {
  const { firstName, lastName, size } = props;
  const classes = useStyles({ size });
  return (
    <Paper elevation={0} className={classes.circle}>
      <div className={classes.inner}>
        {firstCharacterExtractor(firstName)}
        {firstCharacterExtractor(lastName)}
      </div>
    </Paper>
  );
};

ProfileCircle.propTypes = {
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  size: PropTypes.string,
};

export default ProfileCircle;
